var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortugal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1199_29004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.000488281 10.0006C-0.000488281 14.3002 2.71326 17.9656 6.52119 19.3785L7.3908 10.0005L6.52119 0.622559C2.71326 2.03553 -0.000488281 5.70092 -0.000488281 10.0006Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 10C20.0003 4.47719 15.5231 0 10.0003 0C8.77709 0 7.60533 0.220039 6.52197 0.621992V19.378C7.60533 19.78 8.77709 20 10.0003 20C15.5231 20 20.0003 15.5228 20.0003 10Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5217 13.4787C8.44268 13.4787 9.99994 11.9214 9.99994 10.0005C9.99994 8.07948 8.44268 6.52222 6.5217 6.52222C4.60072 6.52222 3.04346 8.07948 3.04346 10.0005C3.04346 11.9214 4.60072 13.4787 6.5217 13.4787Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56494 8.2605V10.4344C4.56494 11.515 5.44088 12.3909 6.52147 12.3909C7.60205 12.3909 8.47799 11.515 8.47799 10.4344V8.2605H4.56494Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52182 11.0864C6.16221 11.0864 5.86963 10.7938 5.86963 10.4342V9.5647H7.17396V10.4343C7.17396 10.7938 6.88139 11.0864 6.52182 11.0864Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1199_29004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/portugal.11bfc89bb2bb606268645de610136f5d.svg";
export { ForwardRef as ReactComponent };